import { composeIO } from 'react-compose-io'
import { controleInadimplenciasIO } from './ControleInadimplencias.IO'
import { ControleInadimplenciasView } from './ControleInadimplencias.View'

export const ControleInadimplencias = composeIO(ControleInadimplenciasView, controleInadimplenciasIO)
